import {
  DashboardModuleListItem, ListItem, Text,
} from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import type { SecondaryGroupModel } from '@functions/publicationEdition'

import OrderListItem from './OrderListItem'

interface AgencyGroupProps {
  editionAgency: SecondaryGroupModel,
  isLastGroup: boolean,
}

const AgencyGroup = (props: AgencyGroupProps) => {
  const { editionAgency, isLastGroup } = props
  const { id: editionAgencyId, entityIds: editionAgencyOrderIds } = editionAgency

  const { agencies } = useSelector(reduxState => reduxState.entities)

  const agency = agencies[editionAgencyId] || {}

  const agencyOrderCount = editionAgencyOrderIds.length || 0
  const tertiaryText = agencyOrderCount === 1 ? '1 Editorial' : `${agencyOrderCount} Editorials`

  return (
    <>
      <DashboardModuleListItem title={<Text fontWeight={600}>{agency.title}</Text>}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.TertiaryText>
          <Text color="faintGrey">{tertiaryText}</Text>
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      </DashboardModuleListItem>

      {editionAgencyOrderIds.map((id: number) => (
        <OrderListItem key={id} orderId={id} />
      ))}

      {/* A list item break between Agency Groups */}
      {!isLastGroup && (
        // @ts-expect-error TS2741
        <ListItem
          disableHover
          borderColor="lineColor"
          boxProps={{ borderBottom: '1px dashed', minHeight: '51px' }}
        />
      )}
    </>
  )
}

export default AgencyGroup
